import { axiosInstanceEvents } from "./instance";

export const getTicketInfo = (uuid) => {
  return axiosInstanceEvents.get(`/tickets/get-ticket-by-uuid?uuid=${uuid}`);
};

export const updateOrCreateGuest = (body) => {
  return axiosInstanceEvents.post(`/guest/create-or-update`, body);
};
